export default __webpack_public_path__ + "static/media/comfortaa-regular-webfont.d03ac4bd.woff";